import React, { Component } from 'react';
import { Gelbox } from "@learningblocks/storybook-components";
import { toast } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"
import { css } from 'glamor'
import Toast from '../../../toast/Toast'
import colors from  '@learningblocks/protocol-constants/lib/Styles/_colors.scss';

const toasterNotify = (type, msg, title) => {
    let color = "";
    if (type === "HINT") {
      color = colors.yellow1;
    } else {
      color = colors.red1;
    }

    toast(<Toast type={type} msg={msg} title={title} />, {
      className: css({
        border: "2px solid " + color,
        borderRadius: "6px",
        marginLeft: "-200px",
        minWidth: "400px",
        paddingLeft: 0
      }),
      progressClassName: css({
        background: color
      }),
      position: "top-center",
      autoClose: 5000
    });
};

export const NOTIFY_EVENTS = {
  NOT_RUNNABLE: {
    title: "Microcentrifuge open or not balanced!",
    message: "Ensure that the tubes are balanced and the lid of centrifuge is closed."
  }
};

export class Graphics extends Component {

  toggleToolTipControls = (showControls) => {
    this.props.toggleToolTipControls({
      id: this.props.id,
      showToolTipControls: showControls
    })
  }
  showGelModal = () => {
    this.props.setModal({
        type: 'GEL_PIPETTE',
        size: 'lg',
        pipetteId: this.props.id,
        gelId: 1,
        gelBoxId: 1,
      });
    this.props.showModal({display: true});
}

  toggleOpen = () => {
    if(this.props.anodeConnected || this.props.cathodeConnected){

      this.makeToast("WARNING", "Please remove the power cords before attempting to open the gel box.", "Gel box leads connected!");

    } else {
      this.props.gelBoxOpen({
        id: this.props.id,
        open: !this.props.open
      })
    }
  }

  showGelBoxOrientationModal = () => {

    this.props.setModal({
      type: 'GEL_POSITION',
      size: 'lg',
      connect: this.props.id
    });

    this.props.showModal({ display: true});

  }

  ejectGel = () => {
    console.log('attempting to eject gel');

    this.props.ejectGelFromGelBox({
      id: this.props.id
    })

    this.props.setGelOnShelf({
      id: this.props.id,
      onShelf: true
    });

    this.props.setGelHeld({
      id: this.props.id,
      held: false
    });

    this.props.setGelInScene({
      id: this.props.id,
      inScene: true,
    });
  }

  makeToast = (type, msg, title) => {
   let color = ""
   if(type==="HINT"){
     color = colors.yellow1
   } else {
     color = colors.red1
   }

   toast(<Toast type={type} msg={msg} title={title} />,{
     className: css({
       border: "2px solid "+color,
       borderRadius: "6px",
       marginLeft: "-200px",
       minWidth: "400px",
       paddingLeft: 0
     }),
     progressClassName: css({
       background: color
     }),
     position: "top-center",
     autoClose: 5000,
   });
 }

  render() {
    return(
      <Gelbox
        id={this.props.id}

        pipetteId={this.props.pipetteId}
        gelId={this.props.gelId}

        open={this.props.open}
        orientation={this.props.gelOrientation}
        gelOrientation={this.props.gelOrientation}
        decGelOrientation={this.props.decGelOrientation}
        incGelOrientation={this.props.incGelOrientation}
        containsGel={this.props.containsGel}
        volume={this.props.volume}

        alert={(event) => toasterNotify("WARNING", NOTIFY_EVENTS[event].message, NOTIFY_EVENTS[event].title)}
        toggleLid={(props) =>
          this.props.gelBoxOpen({
            id: this.props.id,
            open: props
          })
        }
        toggleShowTooltipControls={(props) => (
          this.props.toggleGelboxTooltipsControls({
            id: this.props.id,
            showTooltipControls: props
          })
        )}
        showTooltipControls={this.props.showTooltipControls}
        toggleShowOrientationModal={(props) =>
          this.props.toggleGelboxOrientationModal({
            id: this.props.id,
            showOrientationModal: props
          })
        }
        showOrientationModal={this.props.showOrientationModal}
        toggleShowGelPipetteModal={(props) =>
          this.props.toggleGelboxPipetteModal({
            id: this.props.id,
            showGelPipetteModal: props
          })
        }
        lanes={this.props.lanes}
        showGelPipetteModal={this.props.showGelPipetteModal}
        // onInsertItem={(props) => {
        //   return this.props.setGelInBox({
        //     id: this.props.id,
        //     ...props,
        //   })
        // }}
        setGelLane={this.props.setGelLane}
        setGelActiveLane={this.props.setGelActiveLane}
        setPipetteSolution={this.props.setPipetteSolution}
        interactionProps={this.props.interactionProps}
        onEjectGel={(props) => {
          this.props.ejectGelFromGelBox({
            id: 1
          })
          this.props.setGelOnShelf({
            id: 1,
            onShelf: true
          })
          this.props.setGelInScene({
            id: 1,
            inScene: true
          })
        }}
      />
    )
  }
}
